const TransactionCashFlowType = {
    IN: 'IN',
    OUT: 'OUT'
}

export default TransactionCashFlowType;